import {  useGetRelationsOutByIdQuery } from '../../services/objects';
import { ICO2Rate, ICostRate, IEnergyRate } from '../../automationObjects/Energy/EnergyRates';

interface useGetCounterRatesOutput {
    count: number,
    co2Rates: ICO2Rate[] | undefined,
    costRates: ICostRate[] | undefined,
    items: IEnergyRate[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean,
    refetch: () => void
}

function useGetCounterRates(counterId: string, counterResourceGroupId: string): useGetCounterRatesOutput {

    const { data: co2Rates, isLoading, isSuccess, error, refetch: refetch1 } = useGetRelationsOutByIdQuery({ objectId: counterId, resourceGroupId: counterResourceGroupId, type: 'Co2Rate' })
    const { data: costRates, isLoading : isLoading2, isSuccess: isSuccess2, error: error2, refetch: refetch2 } = useGetRelationsOutByIdQuery({ objectId: counterId, resourceGroupId: counterResourceGroupId, type: 'CostRate' })

    const items = [...co2Rates ?? [],...costRates ?? []];

    function refetch() {
        refetch1();
        refetch2();
    }

    return {
        count: items?.length || 0,
        items: items,
        co2Rates: co2Rates,
        costRates: costRates,
        error: error || error2,
        isLoading: isLoading || isLoading2,
        isSuccess: isSuccess && isSuccess2,
        refetch: refetch
    }
}

export default useGetCounterRates